export default __webpack_public_path__ + "static/media/elderly.9bc1673d.webp";